import { Box, makeStyles } from '@material-ui/core';
import { DataGrid, jaJP } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OnOffByScroll from '../../../Animation/onOffByScroll';
import { tagIndexForAdmin } from '../../../Apis/apiOfManaged';
import { AuthContext } from '../../../auth';
import Footer from '../../../Footer/footer';
import various from '../../../General/various';
import { Spinner } from '../../../Spinner';
import BreadCrumbs from '../../../General/breadCrumbs';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    margin: '0px 0px 80px 0px',
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      textAlign: 'start',
      '& > span': {
        display: 'inline-block',
        marginRight: '24px',
        fontSize: '0.9rem',
      },
      '& #title': {
        fontWeight: 'bold',
        fontSize: theme.typography.fontSize,
      },
    },
  },
  container: {
    marginTop: '64px',
  },
  dataGrid: {
    height: (props) =>
      props.heightSize ? props.heightSize : props.pageSize * props.rowHeight,
    width: '100%',
  },
}));

const TagIndex = () => {
  const { authReady, isAuth, permissions } = useContext(AuthContext);
  const hasAdminPermission =
    Array.isArray(permissions) && permissions.includes('admin');

  const [date, setDate] = useState();
  const [tags, setTags] = useState();
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [heightSize, setHeightSize] = useState();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const ROWHEIGHT = 80;
  const PAGESIZE = 30;
  const classes = useStyles({
    pageSize: PAGESIZE,
    rowHeight: ROWHEIGHT,
    heightSize: heightSize,
  });

  const CRUMBS = [
    { name: '管理画面Top', path: '/manage/index' },
    { name: 'タグ一覧', path: '/manage/tag_index' },
  ];

  // Init
  useEffect(() => {
    const weekday = ['日', '月', '火', '水', '木', '金', '土'];
    const d = new Date();
    setDate(
      d.getFullYear() +
        '年' +
        (d.getMonth() + 1) +
        '月' +
        d.getDate() +
        '日' +
        '（' +
        weekday[d.getDay()] +
        '）'
    );
  }, []);

  useEffect(() => {
    if (!authReady || !isAuth || !hasAdminPermission) {
      return;
    }

    setLoading(true);
    tagIndexForAdmin(setTags, 'inuse').then((result) => {
      if (!result) {
        setLoading(false);
      }
    });
  }, [authReady, hasAdminPermission, isAuth]);

  // Handler
  const handleAuth = () => {
    navigate(various.general.login, { state: { previous: location.pathname } });
  };

  const handleClick = (row) => {
    navigate(various.general.tagUpdate, {
      state: { previous: location.pathname, uuid: row.uuid },
    });
  };

  // Contents
  useEffect(() => {
    if (tags) {
      setColumns([
        {
          field: 'id',
          headerName: 'ID',
          width: 10,
        },
        {
          field: 'uuid',
        },
        {
          field: 'name',
          headerName: 'Tagネーム',
          cellClassName: 'tag-name',
          width: 200,
        },
        {
          field: 'is_useful',
          headerName: '運用区分',
          width: 100,
        },
        {
          field: 'description',
          headerName: '説明',
          cellClassName: 'descs-cell',
          width: 400,
        },
        {
          field: 'updateBtn',
          headerName: '更新',
          sortable: false,
          width: 200,
          disableClickEventBubbling: true,
          renderCell: (params) => (
            <div>
              <button onClick={() => handleClick(params.row)}>更新</button>
            </div>
          ),
        },
      ]);

      setRows(
        tags.map((tag, index) => {
          const row = {};
          row['id'] = index + 1;
          row['uuid'] = tag.uuid;
          row['name'] = `#${tag.name}`;
          row['is_useful'] = tag.is_useful ? '運用中' : '運用停止';
          row['description'] = tag.description;
          return row;
        })
      );
      setHeightSize(tags.length * ROWHEIGHT * 1.4 + 122);
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [tags]);

  return (
    <>
      <>
        <div style={{ margin: '80px' }}>
          <OnOffByScroll place="General" />
        </div>
        {!authReady ? (
          <Spinner />
        ) : !isAuth ? (
          <div>
            <span
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={handleAuth}
            >
              ログイン
            </span>
            してください。
          </div>
        ) : hasAdminPermission ? (
          <>
            <div className={classes.pageTitle}>
              <div>
                <span id="title">タグ一覧</span>
                <span>{date}</span>
              </div>
            </div>
            <hr />
            <BreadCrumbs crumbs={CRUMBS} />
            <div className={classes.container}>
              {loading ? (
                <Spinner />
              ) : (
                <Box
                  className={classes.dataGrid}
                  sx={{
                    '& .descs-cell': {
                      '& > div': {
                        overFrow: 'scroll !important',
                      },
                    },
                    '& .tag-name': {
                      fontStyle: 'italic',
                      fontFamily:
                        '"Times New Roman", "YuMincho", "Hiragino Mincho ProN", "Yu Mincho", "MS PMincho", serif',
                      fontWeight: 'bold',
                    },
                  }}
                >
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={PAGESIZE}
                    rowsPerPageOptions={[PAGESIZE]}
                    // checkboxSelection
                    density="comfortable"
                    columnVisibilityModel={{ uuid: false }}
                    pagination={true}
                    autoPageSize={true}
                    rowHeight={ROWHEIGHT}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    localeText={
                      jaJP.components.MuiDataGrid.defaultProps.localeText
                    }
                  />
                </Box>
              )}
            </div>
          </>
        ) : (
          <>
            <div className={classes.pageTitle}>
              <div>
                <span id="title">タグ一覧</span>
                <span>{date}</span>
              </div>
            </div>
            <hr />
            <div className={classes.container}>権限がありません</div>
          </>
        )}
        <Footer />
      </>
    </>
  );
};
export default TagIndex;
